module.exports = __webpack_public_path__ + "videos/home-53-hero_16x9_cn.c950192.mp4";